import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';

const idTypes = ['aadhaar', 'voter_id', 'passport'];

export const GuestFormDialog = ({ open, onOpenChange, onSubmit, formData, setFormData, editingGuest }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-['Manrope']">{editingGuest ? 'Edit Guest' : 'Add New Guest'}</DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label htmlFor="name">Full Name</Label>
          <Input id="name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder="John Doe" required className="border-stone-300" data-testid="guest-name-input" />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder="john@example.com" required className="border-stone-300" data-testid="guest-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="phone">Phone</Label>
            <Input id="phone" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} placeholder="+91 98765 43210" required className="border-stone-300" data-testid="guest-phone-input" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="id_type">ID Type</Label>
            <Select value={formData.id_type} onValueChange={(value) => setFormData({...formData, id_type: value})}>
              <SelectTrigger className="border-stone-300" data-testid="id-type-select"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-white">
                {idTypes.map(type => (<SelectItem key={type} value={type}>{type === 'aadhaar' ? 'Aadhaar' : type === 'voter_id' ? 'Voter ID' : 'Passport'}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="id_number">ID Number</Label>
            <Input id="id_number" value={formData.id_number} onChange={(e) => setFormData({...formData, id_number: e.target.value})} placeholder={formData.id_type === 'aadhaar' ? 'XXXX-XXXX-XXXX' : 'ID Number'} required className="border-stone-300" data-testid="id-number-input" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="nationality">Nationality</Label>
            <Input id="nationality" value={formData.nationality} onChange={(e) => setFormData({...formData, nationality: e.target.value})} placeholder="Indian" className="border-stone-300" data-testid="nationality-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="address">Address</Label>
            <Input id="address" value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} placeholder="123 Main St" className="border-stone-300" data-testid="address-input" />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <input type="checkbox" id="is_foreign" checked={formData.is_foreign || false} onChange={(e) => setFormData({...formData, is_foreign: e.target.checked})} className="rounded border-stone-300" data-testid="is-foreign-checkbox" />
          <Label htmlFor="is_foreign" className="text-sm cursor-pointer">Foreign National (Form-C required)</Label>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-stone-300">Cancel</Button>
          <Button type="submit" className="bg-sage-700 hover:bg-sage-800 text-white" data-testid="save-guest-button">{editingGuest ? 'Update' : 'Create'} Guest</Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
